module.exports = __webpack_public_path__ + "static/media/aptoMedico.3065ce61.pdf";